function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M265.652,166.341c-1.536-2.603-1.579-5.828-0.102-8.465l35.618-64.128h-31.599l-50.543,93.867h28.382 c2.807,0,5.444,1.382,7.031,3.703c1.596,2.313,1.946,5.274,0.93,7.902l-23.791,61.85l74.547-90.522h-33.118 C269.979,170.548,267.188,168.952,265.652,166.341z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.54,155.213C416.759,74.769,352.033,9.907,271.632,0.99c-4.804-0.529-9.873-0.853-15.898-0.99 c-5.615,0.137-10.684,0.461-15.497,0.99C159.846,9.907,95.12,74.769,86.348,155.213c-5.965,54.682,13.252,107.742,52.719,145.596 c18.142,17.399,31.181,37.478,37.547,57.472h158.652c6.366-19.994,19.405-40.073,37.547-57.472 C412.279,262.955,431.496,209.894,425.54,155.213z M330.794,167.441L211.327,312.508c-1.673,2.022-4.113,3.106-6.588,3.106 c-1.476,0-2.953-0.375-4.301-1.152c-3.618-2.125-5.163-6.536-3.669-10.445l38.212-99.337H204.74c-3.004,0-5.786-1.57-7.322-4.156 c-1.544-2.577-1.613-5.777-0.188-8.414l59.733-110.933c1.485-2.773,4.369-4.497,7.509-4.497h51.2c3.029,0,5.82,1.604,7.356,4.207 c1.536,2.603,1.57,5.828,0.102,8.474l-35.618,64.12h36.693c3.302,0,6.306,1.911,7.714,4.898 C333.328,161.357,332.893,164.89,330.794,167.441z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.136,392.418h68.267c4.719,0,8.533,3.814,8.533,8.533s-3.814,8.533-8.533,8.533h-68.267v17.067h42.667 c4.719,0,8.533,3.814,8.533,8.533c0,4.719-3.814,8.533-8.533,8.533h-42.667v25.6c0,4.719,3.823,8.533,8.533,8.533h12.809 l15.352,20.471c6.409,8.55,16.614,13.662,27.307,13.662h25.6c10.692,0,20.907-5.111,27.307-13.662l15.36-20.471h12.8 c4.719,0,8.533-3.814,8.533-8.533v-25.6h-68.267c-4.71,0-8.533-3.814-8.533-8.533c0-4.719,3.823-8.533,8.533-8.533h68.267 v-17.067h-42.667c-4.71,0-8.533-3.814-8.533-8.533s3.823-8.533,8.533-8.533h42.667v-17.067h-153.6V392.418z M290.069,477.751 l-7.68,10.24c-3.2,4.275-8.303,6.827-13.653,6.827h-25.6c-5.342,0-10.445-2.551-13.653-6.827l-7.68-10.24H290.069z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgGlow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "rotate(90 50 50)",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.885 511.885",
    style: {
      enableBackground: "new 0 0 511.885 511.885"
    },
    xmlSpace: "preserve",
    stroke: "black",
    strokeWidth: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlow1);
export default __webpack_public_path__ + "static/media/glow_1.fb5f2b76.svg";
export { ForwardRef as ReactComponent };